module.exports = __webpack_public_path__ + "img/milho.80c91247.svg";